import React from 'react';
import { Tooltip as EcoTooltip } from "@bsw/react-nightingale";
import { TooltipSpotlight } from "../../index";
import './tooltip.scss';

export const Tooltip = ({
    children,
    text,
    tooltipId,
    linkText,
    open,
    placement,
    onClick = () => { },
    linkOnClick = () => { onClick() },
    scrollIntoView,
    variant = 'primary',
}) => {

    const tooltip = <EcoTooltip open={open}
        text={text}
        tooltipId={tooltipId}
        linkOnClick={linkOnClick}
        linkText={linkText}
        placement={placement}
        variant={variant}
    >
        {children}
    </EcoTooltip>;

    return (<> {variant === 'spotlight'
        ? <TooltipSpotlight
            open={open}
            tooltip={tooltip}
            linkOnClick={linkOnClick}
            scrollIntoView={scrollIntoView}
        >
            {children}
        </TooltipSpotlight>
        : tooltip
        } </>
    );
}
